import React from 'react'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'
import AddBlogsComponent from '../../../Components/AdminComponent/AddBlogsComponent/AddBlogsComponent'

const AddBlogs = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <AdminHeader />
            <div className='row col-lg-12'>
                <AdminSidebar />
                <div className='col-lg-10 right_content'>
                    <AddBlogsComponent 
                    />

                </div>
            </div>
        </div>
  )
}

export default AddBlogs
